const registrationForm = document.getElementById('registration-form');

if (registrationForm) {
    registrationForm.addEventListener('submit', () => {
        var _paq = window._paq = window._paq || [];
        _paq.push(['trackEvent', 'Anmeldungen', 'Anmeldung', registrationForm.dataset.eventTitle]);
    });
}
